import {
  FleetDocumentEditFormValues,
  FleetDocumentSearchFormValues,
} from "./types";

export const initialFleetVehicleDocumentSearchForm: FleetDocumentSearchFormValues =
  {
    search: "",
    documentTypeId: null,
    createdFrom: null,
    createdTo: null,
  };

export const initialFleetVehicleDocumentEditForm: FleetDocumentEditFormValues =
  {
    name: null,
    description: null,
    documentTypeId: null,
    files: []
  };
